import logo from "../assets/meatrix-logo.png";

export function BrandLogo({ className }: { className?: string }) {
  return <img src={logo} alt="MEATrix OrderFlow" className={className} />;
}
